// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiGrid-root.upload-mainContainerReels{
    background-color: #292B49;
    padding: 20px;
    width: 100%;
}
@media screen and (min-width: 1024px){
      .MuiGrid-root.upload-mainContainerReels{
        min-height: 780px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Reels/Reels.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,WAAW;AACf;AACA;MACM;QACE,iBAAiB;IACrB;AACJ","sourcesContent":[".MuiGrid-root.upload-mainContainerReels{\n    background-color: #292B49;\n    padding: 20px;\n    width: 100%;\n}\n@media screen and (min-width: 1024px){\n      .MuiGrid-root.upload-mainContainerReels{\n        min-height: 780px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
